export const SCROLL_MARGIN = 8;
export const MIN_HEIGHT_LINES = 15;
export const ACE_ELEMENT_ID = "id_sql";
